// context/AIPageContext.js — Kontrak "AI page-context" untuk Opsi B.
//
// Halaman LIVE (real-time, tak menyimpan data ke tabel — mis. SAP Basis Monitor)
// bisa mengekspos RINGKASAN data yang sedang tampil agar AI Assistant di header
// bisa menjelaskan/meringkasnya, TANPA text-to-SQL.
//
// Kontrak: halaman memanggil setPageAI({ key, label, summary }) saat datanya
// termuat, dan setPageAI(null) saat unmount / data kosong.
//   - key     : dashboard key halaman (mis. 'sap_basis_mon') — untuk cocokkan
//               dengan halaman aktif; context diabaikan bila key ≠ halaman aktif.
//   - label   : nama tampilan halaman (mis. 'SAP Basis Monitor').
//   - summary : ringkasan data live (string ATAU objek) yang halaman rakit
//               sendiri — bukan data mentah penuh. Dikirim apa adanya ke AI.
//
// Hook praktis: usePageAIContext(key, label, summary, deps) — daftar & auto-clear.
import React, { createContext, useContext, useState, useCallback, useEffect, useMemo } from 'react';

const AIPageContext = createContext(null);

export function AIPageContextProvider({ children }) {
  const [pageAI, setPageAIState] = useState(null); // { key, label, summary } | null
  const setPageAI = useCallback((v) => setPageAIState(v || null), []);
  const value = useMemo(() => ({ pageAI, setPageAI }), [pageAI, setPageAI]);
  return <AIPageContext.Provider value={value}>{children}</AIPageContext.Provider>;
}

// Konsumen umum (mis. DashboardContainer) — baca/atur context.
export function useAIPage() {
  return useContext(AIPageContext) || { pageAI: null, setPageAI: () => {} };
}

// Hook untuk HALAMAN penyedia: daftarkan context saat `summary` siap,
// bersihkan saat unmount. `summary` null/undefined → context di-clear.
export function usePageAIContext(key, label, summary) {
  const { setPageAI } = useAIPage();
  useEffect(() => {
    if (summary == null || summary === '') { setPageAI(null); return undefined; }
    setPageAI({ key, label, summary });
    return () => setPageAI(null);
  }, [key, label, summary, setPageAI]);
}

export default AIPageContext;
